
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55","height":"111"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.9 111H10.1c-5 0-9.1-4.1-9.1-9.1V10.1C1 5.1 5.1 1 10.1 1H46c5 0 9.1 4.1 9.1 9.1V102c-.1 4.9-4.2 9-9.2 9zM10.1 3C6.2 3 3 6.2 3 10.1V102c0 3.9 3.2 7.1 7.1 7.1H46c3.9 0 7.1-3.2 7.1-7.1V10.1C53 6.2 49.8 3 45.9 3H10.1zM0 16h1v5H0zM0 26h1v5H0zM0 35h1v5H0z"}}),_c('path',{attrs:{"d":"M24 7h7c.6 0 1 .4 1 1s-.4 1-1 1h-7c-.6 0-1-.4-1-1s.4-1 1-1zM27.5 108c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5zm0-7c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zM34 0h9v1h-9z"}}),_c('g',[_c('path',{attrs:{"d":"M6 14h44v82H6z","opacity":".1"}}),_c('path',{attrs:{"d":"M51 97H5V13h46v84zM7 95h42V15H7v80z"}})])])
          )
        }
      }
    